module.exports = __webpack_public_path__ + "static/media/pfbg_768@2x.0099dea3.jpg";